/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GcpResetResponse { 
    status?: GcpResetResponse.StatusEnum;
    errors?: Array<string>;
}
export namespace GcpResetResponse {
    export type StatusEnum = 'SUCCEEDED' | 'FAILED';
    export const StatusEnum = {
        SUCCEEDED: 'SUCCEEDED' as StatusEnum,
        FAILED: 'FAILED' as StatusEnum
    };
}


